/* afx-homepage-perf.js v2 — Lightweight homepage performance optimizations
 * v1 caused CLS issues with content-visibility. v2 is minimal and safe.
 * Only does: resource hints + image lazy-loading + hero preload.
 */
(function() {
  'use strict';

  /* 1. RESOURCE HINTS — Preconnect to critical origins */
  var domains = [
    'https://cdn.shopify.com',
    'https://cdn.shopifycdn.net'
  ];
  domains.forEach(function(d) {
    if (document.querySelector('link[rel="preconnect"][href="' + d + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = d;
    l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  });

  /* 2. HERO IMAGE — Mark first slideshow image as high priority */
  function boostHero() {
    var hero = document.querySelector(
      '[data-section-type*="slideshow"] img, .slideshow img'
    );
    if (hero) {
      hero.loading = 'eager';
      hero.fetchPriority = 'high';
      hero.decoding = 'sync';
    }
  }

  /* 3. LAZY-LOAD BELOW-FOLD IMAGES (safe, no CLS) */
  function lazyImages() {
    var vh = window.innerHeight;
    document.querySelectorAll('img').forEach(function(img) {
      if (img.getBoundingClientRect().top > vh * 1.2) {
        img.loading = 'lazy';
        img.decoding = 'async';
      }
    });
  }

  /* INIT — run after DOM ready */
  function init() {
    boostHero();
    lazyImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
